import { _ } from "../../core/polyglot/polyglot.js";
import AbstractBusinessTrendComparisonElement from "./AbstractBusinessTrendComparisonElement.js";

/**
 * Represents a budget for the user to compare to the current fiscal
 * year.
 *
 * @param {Budget} budget
 * @param {polyglotObject} groupName - The category in which the
 * receiver should be classified. E.g., _("This year's budgets") or
 * _("Other year's budgets"),
 */
export default class BudgetBusinessTrendComparisonElement extends AbstractBusinessTrendComparisonElement {
	constructor({ budget, groupName }) {
		super(...arguments);

		this._budget = budget;
		this._groupName = groupName;
	}

	getId() {
		return this._budget.getId();
	}

	getGroupName() {
		return this._groupName;
	}

	getName() {
		return this._budget.getName();
	}

	fetchAnnualTrend({ fetchAnnualTrendForBudget }) {
		return fetchAnnualTrendForBudget(this._budget.getId());
	}

	isCurrent() {
		return this._budget.isCurrent();
	}

	getNameRenderer({ router }) {
		const url = this._pageUrl(router);
		const name = this.getName();

		return (html) => html.a({ href: url }, name);
	}

	getPeriodNameRenderer({ router }) {
		return _("the budget {budgetName} in {period}", {
			budgetName: this.getNameRenderer({ router }),
			period: super.getPeriodNameRenderer(...arguments),
		});
	}

	_pageUrl(router) {
		return router.linkTo("budget-editor/#budgetId", {
			budgetId: this.getId(),
		});
	}

	_getFiscalYear() {
		return this._budget.getFiscalYear();
	}
}
